import React from 'react';
import SampleForm from '../components/SampleForm'
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Form,DatePicker,Select,Modal,List,Card } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,DownloadOutlined,LoadingOutlined,PrinterOutlined,BarcodeOutlined,EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn'
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import moment from 'moment';
import DeliveryReceivingForm from './DeliveryReceivingForm';
import DeliveryEditForm from './DeliveryEditForm';
import { Tabs } from 'antd';

const { TabPane } = Tabs;



var CryptoJS = require("crypto-js");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const FormItem=Form.Item;
var token= ''
var bizuserid = '';
const { Search } = Input;
const { Option } = Select;


const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;



class ReportToPrint2 extends React.Component {

  state = {
    companyprofile:{},
  };

  componentDidMount(){

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/app_profile/${1}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })



  }


  render() {
    return (
      <div style={{padding:'30px', fontFamily:'Arial, sans-serif', backgroundColor:'white'}}>
            {/* Header Section */}
            <div style={{borderBottom:'3px solid #1890ff', paddingBottom:'20px', marginBottom:'30px'}}>
              <Row> 
                <Col xs="3" sm="3" lg="3">
                  <img height="80" width="100" alt="Logo" src={this.state.companyprofile.company_logo} 
                       style={{border:'1px solid #ddd', borderRadius:'5px'}} />
                </Col>
                <Col xs="9" sm="9" lg="9">
                  <div style={{textAlign:'left'}}>
                    <h2 style={{fontWeight:'bold', color:'#1890ff', margin:'0', fontSize:'24px'}}>
                      {this.state.companyprofile.system_name}
                    </h2>
                    <p style={{margin:'5px 0', fontSize:'14px', color:'#666'}}>
                      <strong>Tel:</strong> {this.state.companyprofile.RegisteredPhoneNumber1}
                    </p>               
                    <p style={{margin:'5px 0', fontSize:'14px', color:'#666'}}>
                      <strong>Email:</strong> {this.state.companyprofile.company_email}
                    </p>
                    <p style={{margin:'5px 0', fontSize:'12px', color:'#999'}}>
                      Generated on: {new Date().toLocaleDateString('en-GB')} at {new Date().toLocaleTimeString('en-GB')}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            {/* Report Title */}
            <div style={{textAlign:'center', marginBottom:'25px'}}>
              <h2 style={{
                fontWeight:'bold', 
                color:'#333', 
                margin:'0',
                fontSize:'20px',
                textTransform:'uppercase',
                letterSpacing:'1px'
              }}>
                HUB DELIVERIES REPORT
              </h2>
              <p style={{fontSize:'14px', color:'#666', margin:'8px 0'}}>
                Period: <strong>{this.props.dateone}</strong> to <strong>{this.props.datetwo}</strong>
              </p>
              <p style={{fontSize:'12px', color:'#999', margin:'5px 0'}}>
                Total Records: <strong>{this.props.pending_deliveries.length}</strong>
              </p>
            </div>

            {/* Professional Table */}
            <reactstrp.Table bordered hover style={{fontSize:'11px', backgroundColor:'white'}}>
                <thead style={{backgroundColor:'#f8f9fa'}}>
                  <tr>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6', textAlign:'center'}}>#</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Order No</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Agent</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Collection Point</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Destination</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Item Type</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Item</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Barcode</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Patient</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Barcode Type</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Parent Code</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Date</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Status</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Pickup Time</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Delivery Time</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Turnaround Time</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Qty</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Received</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Received By</th>  
                    <th style={{padding:'8px 6px', fontWeight:'bold', borderRight:'1px solid #dee2e6'}}>Receive Time</th>
                    <th style={{padding:'8px 6px', fontWeight:'bold'}}>Notes</th>
                  </tr>
                </thead>
                <tbody>
                { this.props.pending_deliveries.map(
                  (item, index)=>(
                    <tr key={item.id} style={{backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                     <td style={{padding:'6px', textAlign:'center', borderRight:'1px solid #dee2e6', fontWeight:'500'}}>{index + 1}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6', fontWeight:'500', color:'#1890ff'}}>{item.delivery_number}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.agent_account_name || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.pickup_point || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.destination || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.item_type || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.item_name || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6', fontFamily:'monospace', fontSize:'10px'}}>{item.barcode || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.patient_name || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>
                       <span style={{
                         padding: '2px 6px',
                         borderRadius: '4px',
                         fontSize: '10px',
                         fontWeight: '500',
                         backgroundColor: item.barcode_type === 'parent' ? '#e6f7ff' : item.barcode_type === 'child' ? '#f6ffed' : '#f0f0f0',
                         color: item.barcode_type === 'parent' ? '#1890ff' : item.barcode_type === 'child' ? '#52c41a' : '#666'
                       }}>
                         {item.barcode_type || 'N/A'}
                       </span>
                     </td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6', fontFamily:'monospace', fontSize:'10px'}}>
                       {item.parent_code || 'N/A'}
                     </td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.orig_date || item.date}</td>
                     <td style={{
                       padding:'6px', 
                       borderRight:'1px solid #dee2e6',
                       color: item.delivery_status === 'pending' ? '#fa8c16' : item.delivery_status === 'delivered' ? '#52c41a' : '#666',
                       fontWeight:'500',
                       textTransform:'capitalize'
                     }}>
                       {item.delivery_status}
                     </td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.time_of_pickup || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.time_of_dropoff || 'N/A'}</td>
                     <td style={{ 
                       padding:'6px', 
                       borderRight:'1px solid #dee2e6',
                       color: item.turn_around_time ? (item.turn_around_time === '00:00:00' ? '#52c41a' : '#1890ff') : '#999',
                       fontWeight:'500'
                     }}>
                       {item.turn_around_time || 'N/A'}
                     </td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6', textAlign:'center'}}>{item.items_total || '0'}</td>
                     <td style={{
                       padding:'6px', 
                       borderRight:'1px solid #dee2e6',
                       color: item.received_by_coordinator ? '#52c41a' : '#ff4d4f',
                       fontWeight:'500'
                     }}>
                       {item.received_by_coordinator ? 'Yes' : 'No'}
                     </td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.received_by || 'N/A'}</td>
                     <td style={{padding:'6px', borderRight:'1px solid #dee2e6'}}>{item.time_of_receiving || 'N/A'}</td>
                     <td style={{padding:'6px', fontSize:'10px'}}>{item.receivers_note || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
            </reactstrp.Table>

            {/* Footer Section */}
            <div style={{marginTop:'30px', borderTop:'2px solid #f0f0f0', paddingTop:'15px'}}>
              <Row>
                <Col xs="6" sm="6" lg="6">
                  <div style={{fontSize:'12px', color:'#666'}}>
                    <p><strong>Report Summary:</strong></p>
                    <p>• Total Deliveries: {this.props.pending_deliveries.length}</p>
                    <p>• Successful: {this.props.pending_deliveries.filter(item => item.delivery_status === 'delivered').length}</p>
                    <p>• Pending: {this.props.pending_deliveries.filter(item => item.delivery_status === 'pending').length}</p>
                    <p>• Received by Coordinator: {this.props.pending_deliveries.filter(item => item.received_by_coordinator).length}</p>
                  </div>
                </Col>
                <Col xs="6" sm="6" lg="6">
                  <div style={{textAlign:'right', fontSize:'11px', color:'#999'}}>
                    <p>This is a computer-generated report.</p>
                    <p>© {new Date().getFullYear()} {this.state.companyprofile.system_name}</p>
                    <p>Generated by: Umoja Delivery Management System</p>
                  </div>
                </Col>
              </Row>
            </div>
      </div>
    );
  }
}



class Hub_DeliveriesList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    pending_deliveries: [],
    pending_deliveries_placeholders: [],

    datarequested:true,
    selected_record:{},
    dateone:'',
    datetwo:'',
    delivery_status:'All',
    userprofile:{},
    
    // Tab management
    activeTab: 'child',
    
    // Barcode search states
    barcodeSearchValue: '',
    barcodeSearchResults: [],
    barcodeSearchActive: false,
    barcodeResultsModalVisible: false,
    detailedBarcodeResults: [],
    
    // Repackage states
    repackageModalVisible: false,
    selectedBarcodeForRepackage: null,
    repackageReason: '',
    repackageLoading: false,

    // Delivery Receiving Modal states
    deliveryReceivingModalVisible: false,
    selectedDeliveryForReceiving: null,

    // Edit and Delete states
    editModalVisible: false,
    selectedDeliveryForEdit: null,
    deleteLoading: false
  };

  componentDidMount(){
    this.data_loaded()
 
}

data_loaded = () => {

      //set dates
    this.setState({dateone:this.getLastWeekMondayToToday().lastWeekMonday}) 
    this.setState({datetwo:this.getLastWeekMondayToToday().today})


    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
      bizuserid= ''
    }

    

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    /*
    axios.get(serverconfig.backendserverurl+`/api/pending_deliveries`)
    .then(res => {

        this.setState({
            pending_deliveries:res.data
        })
        this.setState({
          pending_deliveries_placeholders:res.data
      })
        
        this.setState({datarequested:false})

    })
    */

    //get todays data

  axios.get(serverconfig.backendserverurl+`/api/accounts/${bizuserid}/`)
  .then(res => {
      this.setState({
        userprofile:res.data
      })

  })



    let form_data = new FormData();
    form_data.append('dateone', this.getLastWeekMondayToToday().lastWeekMonday);
    form_data.append('datetwo', this.getLastWeekMondayToToday().today);
    form_data.append('delivery_status', this.state.delivery_status);
    form_data.append('hub', localStorage.getItem("coodinated_hub"));

    if(this.getLastWeekMondayToToday().lastWeekMonday===''||this.getLastWeekMondayToToday().today===''){
      message.error("Please dates are missing")
    }else{
      this.setState({datarequested:true})
      this.setState({pending_deliveries:[]})
      this.setState({pending_deliveries_placeholders:[]})

      //Now submit sale data to database
      axios.post(serverconfig.backendserverurl+'/customqueries/getumoja_deliveriesreport', form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
      .then(res =>{
        this.setState({datarequested:false})
        this.setState({pending_deliveries:JSON.parse(res.data.report)})
        this.setState({pending_deliveries_placeholders:JSON.parse(res.data.report)})

      }).catch(error => console.log(error)) 
    } 


}



    //get dates
   getLastWeekMondayToToday=()=> {
    const today = new Date();
  
    const day = today.getDay();
    const mondayIndex = (day + 6) % 7;
  
    const thisWeekMonday = new Date(today);
    thisWeekMonday.setDate(today.getDate() - mondayIndex);
  
    const lastWeekMonday = new Date(thisWeekMonday);
    lastWeekMonday.setDate(thisWeekMonday.getDate() - 7);
  
    const formatDate = (date) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };
  
    return {
      lastWeekMonday: formatDate(lastWeekMonday),
      today: formatDate(today)
    };


  }




getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

// Tab management methods
handleTabChange = (activeKey) => {
  this.setState({ activeTab: activeKey });
};

getFilteredDeliveries = () => {
  const { pending_deliveries, activeTab } = this.state;
  
  // First apply search/filter results, then apply tab filtering
  let filteredData = pending_deliveries;
  
  if (activeTab === 'child') {
    // "Tracking as single" - shows child items (individual samples)
    filteredData = filteredData.filter(item => 
      item.barcode_type === 'child'
    );
  } else if (activeTab === 'parent') {
    // "Tracking in batch/package" - shows parent items (containers)
    filteredData = filteredData.filter(item => 
      !item.barcode_type || item.barcode_type === 'parent'
    );
  }
  
  return filteredData;
};

getTabCounts = () => {
  const { pending_deliveries } = this.state;
  
  // Count based on current search/filter results
  const singleCount = pending_deliveries.filter(item => 
    item.barcode_type === 'child'
  ).length;
  
  const batchCount = pending_deliveries.filter(item => 
    !item.barcode_type || item.barcode_type === 'parent'
  ).length;
  
  return { singleCount, batchCount };
};

// Barcode search functionality
handleBarcodeSearch = () => {
  const { barcodeSearchValue, pending_deliveries_placeholders } = this.state;
  
  if (!barcodeSearchValue.trim()) {
    message.warning('Please enter a barcode to search');
    return;
  }

  const detailedResults = [];
  const matchingDeliveries = [];

  pending_deliveries_placeholders.forEach(delivery => {
    try {
      if (delivery.delivery_items) {
        const items = JSON.parse(delivery.delivery_items);
        const matchingItems = [];
        
        // Search through all items
        items.forEach(item => {
          // Check if the item itself matches
          if (item.barcode && 
              item.barcode.toLowerCase().includes(barcodeSearchValue.toLowerCase())) {
            matchingItems.push({
              ...item,
              matchType: 'parent',
              deliveryNumber: delivery.delivery_number,
              deliveryDate: delivery.date,
              deliveryStatus: delivery.delivery_status,
              agentName: delivery.agent_account_name,
              pickupPoint: delivery.pickup_point,
              destination: delivery.destination
            });
          }
          
          // Check children if they exist (for batch/package items)
          if (item.children && Array.isArray(item.children)) {
            item.children.forEach(child => {
              if (child.barcode && 
                  child.barcode.toLowerCase().includes(barcodeSearchValue.toLowerCase())) {
                matchingItems.push({
                  ...child,
                  parentBarcode: item.barcode,
                  parentItemType: item.item_type,
                  matchType: 'child',
                  deliveryNumber: delivery.delivery_number,
                  deliveryDate: delivery.date,
                  deliveryStatus: delivery.delivery_status,
                  agentName: delivery.agent_account_name,
                  pickupPoint: delivery.pickup_point,
                  destination: delivery.destination
                });
              }
            });
          }
        });
        
        if (matchingItems.length > 0) {
          matchingDeliveries.push(delivery);
          detailedResults.push(...matchingItems);
        }
      }
    } catch (error) {
      console.error('Error parsing delivery items:', error);
    }
  });

  this.setState({
    pending_deliveries: matchingDeliveries,
    barcodeSearchResults: matchingDeliveries,
    detailedBarcodeResults: detailedResults,
    barcodeSearchActive: true,
    barcodeResultsModalVisible: true
  });

  if (detailedResults.length === 0) {
    message.info(`No items found with barcode: ${barcodeSearchValue}`);
  } else {
    message.success(`Found ${detailedResults.length} item(s) with barcode: ${barcodeSearchValue}`);
  }
};

handleBarcodeSearchClear = () => {
  this.setState({
    barcodeSearchValue: '',
    pending_deliveries: this.state.pending_deliveries_placeholders,
    barcodeSearchResults: [],
    barcodeSearchActive: false,
    barcodeResultsModalVisible: false,
    detailedBarcodeResults: []
  });
  message.info('Barcode search cleared');
};

// Repackage functionality
handleRepackageClick = (item) => {
  this.setState({
    selectedBarcodeForRepackage: item,
    repackageModalVisible: true,
    repackageReason: ''
  });
};

handleRepackageSubmit = async () => {
  const { selectedBarcodeForRepackage, repackageReason } = this.state;
  
  if (!repackageReason.trim()) {
    message.warning('Please enter a reason for repackaging');
    return;
  }

  this.setState({ repackageLoading: true });

  try {
    const form_data = new FormData();
    form_data.append('barcode', selectedBarcodeForRepackage.barcode);
    form_data.append('reason_for_repackage', repackageReason);

    const response = await axios.post(
      serverconfig.backendserverurl + '/customqueries/repackage_barcode',
      form_data,
      {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Token ${token}`
        }
      }
    );

    message.success(response.data.message || 'Barcode repackaged successfully');
    
    this.setState({
      repackageModalVisible: false,
      selectedBarcodeForRepackage: null,
      repackageReason: ''
    });

    // Refresh the search results
    this.handleBarcodeSearch();
    
  } catch (error) {
    console.error('Error repackaging barcode:', error);
    message.error(error.response?.data?.message || 'Failed to repackage barcode');
  } finally {
    this.setState({ repackageLoading: false });
  }
};

handleRepackageCancel = () => {
  this.setState({
    repackageModalVisible: false,
    selectedBarcodeForRepackage: null,
    repackageReason: ''
  });
};

  // Delivery Receiving Modal Handlers
  handleDeliveryReceivingOpen = (record) => {
    this.setState({
      deliveryReceivingModalVisible: true,
      selectedDeliveryForReceiving: record
    });
  };

  handleDeliveryReceivingClose = () => {
    this.setState({
      deliveryReceivingModalVisible: false,
      selectedDeliveryForReceiving: null
    });
  };

  handleDeliveryReceivingSuccess = () => {
    // Refresh data and close modal
    this.data_loaded();
    this.handleDeliveryReceivingClose();
    message.success('Delivery received successfully!');
  };

  // Delete delivery functionality
  handleDeleteDelivery = async (record) => {
    this.setState({ deleteLoading: true });
    
    try {
      const response = await axios.delete(
        `${serverconfig.backendserverurl}/customqueries/delete_umoja_delivery/${record.id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`
          }
        }
      );
      
      message.success('Delivery deleted successfully!');
      this.data_loaded(); // Refresh the data
      
    } catch (error) {
      console.error('Error deleting delivery:', error);
      message.error(error.response?.data?.error || 'Failed to delete delivery');
    } finally {
      this.setState({ deleteLoading: false });
    }
  };

  // Edit delivery functionality
  handleEditDelivery = (record) => {
    this.setState({
      selectedDeliveryForEdit: record,
      editModalVisible: true
    });
  };

  handleEditModalClose = () => {
    this.setState({
      editModalVisible: false,
      selectedDeliveryForEdit: null
    });
  };

  handleEditSuccess = () => {
    this.data_loaded(); // Refresh the data
    this.handleEditModalClose();
    message.success('Delivery updated successfully!');
  };

 

  render() {
    const columns = [
      {
        title: 'Order No',
        dataIndex: 'delivery_number',
        key: 'id',
        ...this.getColumnSearchProps('delivery_number'),
      },
       {
        title: 'Agent ',
        dataIndex: 'agent_account_name',
        key: 'id',
        ...this.getColumnSearchProps('agent_account_name'),
      },
       {
        title: 'Collection point ',
        dataIndex: 'pickup_point',
        key: 'id',
        ...this.getColumnSearchProps('pickup_point'),
      },
      {
        title: 'Destination ',
        dataIndex: 'destination',
        key: 'id',
        ...this.getColumnSearchProps('destination'),
      },
    

      {
        title: 'Delivery Type',
        dataIndex: 'item_type',
        key: 'id',
        ...this.getColumnSearchProps('item_type'),
      },

      {
        title: 'Item',
        dataIndex: 'item_name',
        key: 'id',
        ...this.getColumnSearchProps('item_name'),
      },

      {
        title: 'Barcode',
        dataIndex: 'barcode',
        key: 'id',
        render: (text, record) => {
          // Check for children in delivery_items JSON
          let childrenCount = 0;
          try {
            if (record.children && Array.isArray(record.children)) {
              childrenCount = record.children.length;
            } else if (record.delivery_items) {
              const items = typeof record.delivery_items === 'string' ? JSON.parse(record.delivery_items) : (record.delivery_items || []);
              const pkg = items.find(it => 
                (String(it.item_type || '').toLowerCase() === 'batch') 
                && String(it.barcode || '') === String(record.barcode || '')
              );
              if (pkg && Array.isArray(pkg.children)) {
                childrenCount = pkg.children.length;
              }
            }
          } catch (e) {
            // ignore parse errors
          }

          if (record.item_type === 'Batch' && childrenCount > 0) {
            return (
              <div>
                <div style={{fontFamily: 'monospace', fontWeight: 'bold', color: '#1890ff'}}>{text}</div>
                <div style={{fontSize: '11px', color: '#666', marginTop: '2px'}}>
                  📦 {childrenCount} items
                </div>
              </div>
            );
          }
          return <span style={{fontFamily: 'monospace'}}>{text}</span>;
        }
      },

      {
        title: 'Patient',
        dataIndex: 'patient_name',
        key: 'id',
        ...this.getColumnSearchProps('patient_name'),
        render: (text) => (
          <span style={{color: text ? '#1890ff' : '#999'}}>
            {text || 'N/A'}
          </span>
        )
      },

      {
        title: 'Barcode Type',
        dataIndex: 'barcode_type',
        key: 'id',
        ...this.getColumnSearchProps('barcode_type'),
        render: (text) => (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: text === 'parent' ? '#e6f7ff' : text === 'child' ? '#f6ffed' : '#f0f0f0',
            color: text === 'parent' ? '#1890ff' : text === 'child' ? '#52c41a' : '#666'
          }}>
            {text || 'N/A'}
          </span>
        )
      },

      {
        title: 'Parent Code',
        dataIndex: 'parent_code',
        key: 'id',
        ...this.getColumnSearchProps('parent_code'),
        render: (text) => (
          <span style={{fontFamily: 'monospace', color: text ? '#666' : '#999'}}>
            {text || 'N/A'}
          </span>
        )
      },

      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
        ...this.getColumnSearchProps('date'),
      },

      {
        title: 'Delivery status',
        dataIndex: 'delivery_status',
        key: 'id',
        ...this.getColumnSearchProps('delivery_status'),
        render: (text,record) =>
        <p style={{color:record.delivery_status==="pending"?"orange":"green"}}>
           {text}
        </p>
      },
     
     
      {
        title: 'Time of pickup ',
        dataIndex: 'time_of_pickup',
        key: 'id',
      },
      
      {
        title: 'Time of delivery ',
        dataIndex: 'time_of_dropoff',
        key: 'id',
      },
      {
        title: 'Turnaround Time',
        dataIndex: 'turn_around_time',
        key: 'id',
        render: (text) => (
          <span style={{ 
            color: text ? (text === '00:00:00' ? '#52c41a' : '#1890ff') : '#d9d9d9',
            fontWeight: text ? '500' : 'normal'
          }}>
            {text || 'N/A'}
          </span>
        ),
      },
      {
        title: 'Items total ',
        dataIndex: 'items_total',
        key: 'id',
      },

      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'actions',
        width: 150,
        render: (text, record) => (
          <div style={{display:'flex', flexDirection:'column', gap:'4px'}}>
            {(this.state.userprofile.branch_manager === true || this.state.userprofile.coodinated_hub != null) && 
             !record.received_by_coordinator && (
              <Button 
                type="primary" 
                size="small"
                onClick={() => this.handleDeliveryReceivingOpen(record)}
                style={{fontSize:'11px', padding:'2px 8px'}}
              >
                Receive
              </Button>
            )}
            {record.received_by_coordinator && (
              <span style={{fontSize:'10px', color:'#52c41a', fontWeight:'500'}}>
                ✓ Received
              </span>
            )}

            {/* Edit and Delete buttons for hub managers */}
            {(this.state.userprofile.coodinated_hub != null) && (
              <div style={{display:'flex', gap:'4px', marginTop:'4px'}}>
                <Button 
                  type="default" 
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => this.handleEditDelivery(record)}
                  style={{fontSize:'10px', padding:'2px 6px'}}
                  title="Edit delivery"
                >
                  Edit
                </Button>
                
                <Popconfirm
                  title="Are you sure you want to delete this delivery?"
                  description="This action cannot be undone."
                  onConfirm={() => this.handleDeleteDelivery(record)}
                  okText="Yes, Delete"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true, loading: this.state.deleteLoading }}
                >
                  <Button 
                    type="primary" 
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    style={{fontSize:'10px', padding:'2px 6px'}}
                    title="Delete delivery"
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </div>
            )}

          </div>
        )
      },

      {
        title: 'Received?',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
         
          {
            record.received_by_coordinator===true?
            <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start'}}>
            <span style={{color:'green'}}>Received by: {record.received_by}</span>
            <span style={{color:'green'}}>Time: {record.time_of_receiving}</span>
            <span style={{color:'green'}}>Note: {record.receivers_note}</span>
            </div>
            :
            <span style={{color:'red'}}>No</span>
          }

        </p>
      
          
      },


    
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin size="large">
        <div className="content">
          <h3>Umoja couriers</h3>
        </div>
         </Spin> 
          </div>
      )

    }else{
      return(
        <div>

            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint2
              dateone={this.state.dateone}
              datetwo={this.state.datetwo}
              pending_deliveries={this.state.pending_deliveries}
              ref={el => (this.componentRef_2 = el)} /> 
            </div>


            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="UMOJA DELIVERIES" key="1">

            <div style={{display:'flex',justifyContent:'flex-start',flexDirection:'row'}}>
                <ReactToPrint
                  trigger={() => 
                  <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                  Print
                  </Button>
                  }
                  content={() => this.componentRef_2}
                  />
                &nbsp;&nbsp;

                <ExcelFile filename={"UmojaIMCouriers -Deliveries from "+this.state.dateone+" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>} >Download excel </Button>}>
                <ExcelSheet data={this.state.pending_deliveries} name="Deliveries">
                    <ExcelColumn label="Order No" value="delivery_number"/>
                    <ExcelColumn label="Agent" value="agent_account_name"/>
                    <ExcelColumn label="Collection point" value="pickup_point"/>
                    <ExcelColumn label="Destination" value="destination"/>
                    <ExcelColumn label="Delivery Type" value="item_type"/>
                    <ExcelColumn label="Item" value="item_name"/>
                    <ExcelColumn label="Barcode" value="barcode"/>
                    <ExcelColumn label="Patient" value="patient_name"/>
                    <ExcelColumn label="Barcode Type" value="barcode_type"/>
                    <ExcelColumn label="Parent Code" value="parent_code"/>
                    <ExcelColumn label="Date" value="date"/>
                    <ExcelColumn label="Delivery status" value="delivery_status"/>
                    <ExcelColumn label="Time of pickup" value="time_of_pickup"/>
                    <ExcelColumn label="Time of delivery" value="time_of_dropoff"/>
                    <ExcelColumn label="Turnaround Time" value="turn_around_time"/>
                    <ExcelColumn label="Items total" value="items_total"/>
                    <ExcelColumn label="Received by coordinator" value="received_by_coordinator"/>
                    <ExcelColumn label="Received by" value="received_by"/>
                    <ExcelColumn label="Time of receiving" value="time_of_receiving"/>
                    <ExcelColumn label="Receiver's note" value="receivers_note"/>
                </ExcelSheet>
               </ExcelFile>

               &nbsp;&nbsp;

               {/* Barcode Search Component */}
               <div style={{display:'inline-flex', alignItems:'center', gap:'8px'}}>
                 <Input
                   placeholder="Enter barcode to search"
                   value={this.state.barcodeSearchValue}
                   onChange={(e) => this.setState({barcodeSearchValue: e.target.value})}
                   onPressEnter={this.handleBarcodeSearch}
                   style={{width: 200}}
                   prefix={<BarcodeOutlined />}
                 />
                 <Button 
                   type="default" 
                   icon={<SearchOutlined />} 
                   onClick={this.handleBarcodeSearch}
                   style={{backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white'}}
                 >
                   Search Barcode
                 </Button>
                 {this.state.barcodeSearchActive && (
                   <Button 
                     type="dashed" 
                     onClick={this.handleBarcodeSearchClear}
                     style={{color: '#ff7875', borderColor: '#ff7875'}}
                   >
                     Clear ({this.state.barcodeSearchResults.length})
                   </Button>
                 )}
               </div>

               </div>

            <br></br>
            <br></br>

                 <Form  layout="inline" >

                 <FormItem label="Delivery status">
                     <Select 
                     placeholder="Delivery status"
                     style={{ width: 200 }} 
                     value={this.state.delivery_status} 
                     onChange={(val)=>{this.setState({delivery_status:val})}}
                      
                     showSearch
                     optionFilterProp="children"
                     onFocus={this.onFocus}
                     onBlur={this.onBlur}
                     onSearch={this.onSearch}
                     filterOption={(input, option) =>
                       option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                     }                     
                      >
                        <Option value={"All"}>All </Option>
                        <Option value={'pending'}>Pending</Option>
                        <Option value={'delivered'}>Delivered</Option>

                     </Select>
                 </FormItem>


                  <FormItem label="Date Range">
                      <RangePicker onChange={(date, dateString) =>{
                        this.setState({ dateone: dateString[0]});
                        this.setState({ datetwo: dateString[1]});
                      }} format={dateFormat} />
                  </FormItem>

                  <FormItem>
                  <Button onClick={()=>{

                      let form_data = new FormData();
                      form_data.append('dateone', this.state.dateone);
                      form_data.append('datetwo', this.state.datetwo);
                      form_data.append('delivery_status', this.state.delivery_status);
                      form_data.append('hub', localStorage.getItem("coodinated_hub"));

                     if(this.state.dateone===''||this.state.datetwo===''){
                        message.error("Please dates are missing")
                      }else{
                        this.setState({datarequested:true})
                        this.setState({pending_deliveries:[]})
                        this.setState({pending_deliveries_placeholders:[]})
                
                        //Now submit sale data to database
                        axios.post(serverconfig.backendserverurl+'/customqueries/getumoja_deliveriesreport', form_data,{
                        headers: {
                          'content-type': 'multipart/form-data'
                        }
                        })
                        .then(res =>{
                          this.setState({datarequested:false})
                          this.setState({pending_deliveries:JSON.parse(res.data.report)})
                          this.setState({pending_deliveries_placeholders:JSON.parse(res.data.report)})

                        } 
                        )
                        .catch(error => console.log(error))   
                    }

                  }} type="primary" htmlType="button">Search</Button>
                  </FormItem> 
  
             </Form>

            <br></br>

<Form  layout="inline" >

<FormItem label="Filter by agent">
<Search
     placeholder="Filter by agent"
     onChange={(value) => {
       var val=value.target.value
       console.log(val)
       if (val !== '' || val !== undefined) {
         //set one is by NAME
         const results_1 = this.state.pending_deliveries_placeholders.filter((request) => {
           return String(request.agent_account_name).toLowerCase().startsWith(val.toLowerCase());
           // Use the toLowerCase() method to make it case-insensitive
         });
   
         if (results_1.length === 0) {
          this.setState({pending_deliveries:this.state.pending_deliveries_placeholders});

         } else {
           this.setState({pending_deliveries:results_1});
           console.log(results_1)
         }
   
       } else {
         this.setState({pending_deliveries:this.state.pending_deliveries_placeholders});
       }
   
     }}
     style={{
       width: 200,
       margin:5
     }}
     />
 </FormItem>
 </Form>

            <br></br>

            {/* Delivery Items Tabs */}
            <Tabs 
              activeKey={this.state.activeTab} 
              onChange={this.handleTabChange}
              type="card"
              style={{marginTop: '20px'}}
            >
              <TabPane 
                tab={
                  <span>
                    🔬 Tracking as single 
                    <span style={{
                      marginLeft: '8px', 
                      padding: '2px 6px', 
                      backgroundColor: '#f6ffed', 
                      color: '#52c41a', 
                      borderRadius: '10px', 
                      fontSize: '11px'
                    }}>
                      {this.getTabCounts().singleCount}
                    </span>
                  </span>
                } 
                key="child"
              >
                <Table 
              columns={columns} 
              scroll={{ x: 1000 }}
              pagination={{showQuickJumper:true,showSizeChanger:true }}
              dataSource={this.getFilteredDeliveries()}
              bordered
              expandable={{
                defaultExpandAllRows: false,
                expandRowByClick: false,
                expandedRowRender: (record) => {
                  // Always show expandable for batch/package items, even if no children found yet
                  if (String(record.item_type || '').toLowerCase() === 'batch') {
                    console.log('This is a batch item, showing expandable');
                  } else if (String(record.item_type || '').toLowerCase() === 'package') {
                    console.log('This is a package item, showing expandable');
                  } else {
                    console.log('Not a package or batch item, returning null');
                    return null;
                  }

                  let children = [];
                  try {
                    // Check if record has direct children property (for batch items)
                    if (record.children && Array.isArray(record.children)) {
                      children = record.children;
                      console.log('Found direct children:', children);
                    } else {
                      // Parse delivery_items JSON to find children
                      console.log('Parsing delivery_items:', record.delivery_items);
                      const items = typeof record.delivery_items === 'string' ? JSON.parse(record.delivery_items) : (record.delivery_items || []);
                      console.log('Parsed items:', items);
                      
                      const pkg = (items || []).find(it => 
                        (String(it.item_type || '').toLowerCase() === 'package' || String(it.item_type || '').toLowerCase() === 'batch') 
                        && String(it.barcode || '') === String(record.barcode || '')
                      );
                      console.log('Found matching item:', pkg);
                      
                      if (pkg && Array.isArray(pkg.children)) {
                        children = pkg.children;
                        console.log('Found children in delivery_items:', children);
                      }
                    }
                  } catch (e) {
                    console.log('Error parsing children:', e);
                    // ignore parse errors
                  }

                  const mapChildToExisting = (barcode) => {
                    try {
                      return this.state.pending_deliveries_placeholders.find(r => String(r.barcode || '') === String(barcode));
                    } catch (e) {
                      return null;
                    }
                  };

                  if (!children || children.length === 0) {
                    return (
                      <div style={{ padding: 12, color: '#999' }}>
                        <div style={{ marginBottom: '8px' }}>No child items found for this {String(record.item_type || '').toLowerCase() === 'batch' ? 'batch' : 'package'}.</div>
                        <div style={{ fontSize: '12px', color: '#ccc' }}>
                          Debug info: delivery_items = {record.delivery_items ? 'Present' : 'Missing'}
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div style={{ padding: 12 }}>
                      <div style={{ fontWeight: 'bold', marginBottom: 8 }}>
                        {String(record.item_type || '').toLowerCase() === 'batch' ? 'Batch Children' : 'Package Children'}
                      </div>
                      <Table
                        size="small"
                        pagination={false}
                        columns={[
                          { title: 'Child Barcode', dataIndex: 'barcode', key: 'barcode', render: (t) => <span style={{ fontFamily: 'monospace' }}>{t}</span> },
                          { title: 'Type', dataIndex: 'type', key: 'type' },
                          { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
                          { 
                            title: 'Matched Delivery Item', 
                            key: 'match',
                            render: (_, child) => {
                              const match = mapChildToExisting(child.barcode);
                              return match ? (
                                <div style={{ fontSize: 12 }}>
                                  <div><strong>Item:</strong> {match.item_name || 'N/A'}</div>
                                  <div><strong>Status:</strong> <span style={{color: match.delivery_status === 'pending' ? 'orange' : 'green'}}>{match.delivery_status}</span></div>
                                  <div><strong>Qty:</strong> {match.items_total || 0}</div>
                                </div>
                              ) : (
                                <span style={{ color: '#999' }}>No separate record</span>
                              );
                            }
                          }
                        ]}
                        dataSource={children.map((c, idx) => ({ key: `${record.id}-child-${idx}`, ...c }))}
                      />
                    </div>
                  );
                },
                rowExpandable: (record) => String(record.item_type || '').toLowerCase() === 'package'
              }}
            />
              </TabPane>

              <TabPane 
                tab={
                  <span>
                    📦 Tracking in batch/package 
                    <span style={{
                      marginLeft: '8px', 
                      padding: '2px 6px', 
                      backgroundColor: '#e6f7ff', 
                      color: '#1890ff', 
                      borderRadius: '10px', 
                      fontSize: '11px'
                    }}>
                      {this.getTabCounts().batchCount}
                    </span>
                  </span>
                } 
                key="parent"
              >
                <Table 
                  columns={columns} 
                  scroll={{ x: 1000 }}
                  pagination={{showQuickJumper:true,showSizeChanger:true }}
                  dataSource={this.getFilteredDeliveries()}
                  bordered
                />
              </TabPane>
            </Tabs>

            </Panel>
            </Collapse>

            {/* Barcode Search Results Modal */}
            <Modal
              title={`Barcode Search Results - "${this.state.barcodeSearchValue}"`}
              visible={this.state.barcodeResultsModalVisible}
              onCancel={() => this.setState({barcodeResultsModalVisible: false})}
              footer={[
                <Button key="close" onClick={() => this.setState({barcodeResultsModalVisible: false})}>
                  Close
                </Button>
              ]}
              width={800}
            >
              <List
                dataSource={this.state.detailedBarcodeResults}
                renderItem={(item, index) => (
                  <List.Item
                    actions={[
                      item.deliveryStatus === 'delivered' ? (
                        <Button 
                          type="primary" 
                          danger
                          icon={<BarcodeOutlined />}
                          onClick={() => this.handleRepackageClick(item)}
                        >
                          Repackage
                        </Button>
                      ) : (
                        <Button 
                          type="default" 
                          disabled
                          icon={<BarcodeOutlined />}
                          title={`Cannot repackage - Delivery status: ${item.deliveryStatus}`}
                        >
                          Repackage (Only for successful deliveries)
                        </Button>
                      )
                    ]}
                  >
                    <Card 
                      size="small" 
                      style={{width: '100%'}}
                      title={`Item #${index + 1}: ${item.item_name || 'N/A'}`}
                    >
                      <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                        <div><strong>Barcode:</strong> <span style={{color: '#1890ff'}}>{item.barcode}</span></div>
                        <div><strong>Item Type:</strong> {item.item_type || 'N/A'}</div>
                        <div><strong>Quantity:</strong> {item.quantity || 'N/A'}</div>
                        <div><strong>Description:</strong> {item.description || 'N/A'}</div>
                        {item.matchType === 'child' && (
                          <div><strong>Parent:</strong> <span style={{color: '#52c41a'}}>{item.parentBarcode}</span> ({item.parentItemType})</div>
                        )}
                        <div><strong>Match Type:</strong> 
                          <span style={{
                            color: item.matchType === 'child' ? '#52c41a' : '#1890ff',
                            fontWeight: 'bold',
                            backgroundColor: item.matchType === 'child' ? '#f6ffed' : '#e6f7ff',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '12px'
                          }}>
                            {item.matchType === 'child' ? '📦 Child Item' : '📋 Parent Item'}
                          </span>
                        </div>
                      </div>
                      
                      {/* Show children for batch items */}
                      {item.item_type === 'Batch' && item.children && item.children.length > 0 && (
                        <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#e6f7ff', borderRadius: '4px', border: '1px solid #91d5ff'}}>
                          <div style={{fontWeight: 'bold', marginBottom: '8px', color: '#1890ff'}}>
                            📦 Batch Contents ({item.children.length} items):
                          </div>
                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                            {item.children.map((child, childIndex) => (
                              <div key={childIndex} style={{
                                padding: '6px 8px', 
                                backgroundColor: '#f0f9ff', 
                                borderRadius: '4px', 
                                border: '1px solid #bae7ff',
                                fontSize: '12px'
                              }}>
                                <div><strong>Barcode:</strong> <span style={{color: '#1890ff', fontFamily: 'monospace'}}>{child.barcode}</span></div>
                                <div><strong>Type:</strong> {child.type === 'single_entry' ? 'Single' : child.type}</div>
                                <div><strong>Qty:</strong> {child.quantity}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div style={{marginTop: '10px', padding: '8px', backgroundColor: '#f0f2f5', borderRadius: '4px'}}>
                        <div><strong>Delivery:</strong> {item.deliveryNumber} ({item.deliveryDate})</div>
                        <div><strong>Status:</strong> <span style={{color: item.deliveryStatus === 'pending' ? 'orange' : 'green'}}>{item.deliveryStatus}</span>
                          {item.deliveryStatus !== 'delivered' && (
                            <span style={{marginLeft: '8px', color: '#999', fontSize: '12px'}}>
                              (Repackage available only for successful deliveries)
                            </span>
                          )}
                        </div>
                        <div><strong>Agent:</strong> {item.agentName}</div>
                        <div><strong>Route:</strong> {item.pickupPoint} → {item.destination}</div>
                      </div>
                    </Card>
                  </List.Item>
                )}
              />
              {this.state.detailedBarcodeResults.length === 0 && (
                <div style={{textAlign: 'center', padding: '20px', color: '#999'}}>
                  No items found with the specified barcode.
                </div>
              )}
            </Modal>

            {/* Repackage Modal */}
            <Modal
              title="Repackage Item"
              visible={this.state.repackageModalVisible}
              onOk={this.handleRepackageSubmit}
              onCancel={this.handleRepackageCancel}
              confirmLoading={this.state.repackageLoading}
              okText="Repackage"
              okButtonProps={{danger: true}}
            >
              {this.state.selectedBarcodeForRepackage && (
                <div>
                  <Card size="small" style={{marginBottom: '16px', backgroundColor: '#f9f9f9'}}>
                    <div><strong>Item:</strong> {this.state.selectedBarcodeForRepackage.item_name || 'N/A'}</div>
                    <div><strong>Barcode:</strong> <span style={{color: '#1890ff', fontFamily: 'monospace'}}>{this.state.selectedBarcodeForRepackage.barcode}</span></div>
                    <div><strong>Type:</strong> {this.state.selectedBarcodeForRepackage.item_type || 'N/A'}</div>
                    <div><strong>Delivery:</strong> {this.state.selectedBarcodeForRepackage.deliveryNumber}</div>
                  </Card>
                  
                  <div style={{marginBottom: '8px'}}>
                    <strong>Reason for Repackaging: <span style={{color: 'red'}}>*</span></strong>
                  </div>
                  <Input.TextArea
                    placeholder="Enter the reason for repackaging this item..."
                    value={this.state.repackageReason}
                    onChange={(e) => this.setState({repackageReason: e.target.value})}
                    rows={4}
                    maxLength={500}
                    showCount
                  />
                </div>
              )}
            </Modal>

            {/* Delivery Receiving Modal */}
            <Modal
              title={
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <Icon type="inbox" style={{color: '#1890ff'}} />
                  <span>Receive Delivery - {this.state.selectedDeliveryForReceiving?.delivery_number}</span>
                </div>
              }
              visible={this.state.deliveryReceivingModalVisible}
              onCancel={this.handleDeliveryReceivingClose}
              footer={null}
              width={800}
              bodyStyle={{padding: '20px'}}
            >
              {this.state.selectedDeliveryForReceiving && (
                <div>
                  {/* Delivery Information Card */}
                  <Card 
                    size="small" 
                    style={{marginBottom: '20px', backgroundColor: '#f6ffed', border: '1px solid #b7eb8f'}}
                    title={
                      <span style={{color: '#389e0d', fontWeight: 'bold'}}>
                        Delivery Information
                      </span>
                    }
                  >
                    <Row gutter={16}>
                      <Col span={8}>
                        <div><strong>Delivery No:</strong> {this.state.selectedDeliveryForReceiving.delivery_number}</div>
                        <div><strong>Agent:</strong> {this.state.selectedDeliveryForReceiving.agent_account_name}</div>
                      </Col>
                      <Col span={8}>
                        <div><strong>From:</strong> {this.state.selectedDeliveryForReceiving.pickup_point}</div>
                        <div><strong>To:</strong> {this.state.selectedDeliveryForReceiving.destination}</div>
                      </Col>
                      <Col span={8}>
                        <div><strong>Item:</strong> {this.state.selectedDeliveryForReceiving.item_name}</div>
                        <div><strong>Type:</strong> {this.state.selectedDeliveryForReceiving.item_type}</div>
                      </Col>
                    </Row>
                  </Card>

                  {/* Delivery Receiving Form */}
                  <DeliveryReceivingForm 
                    onRefresh={this.handleDeliveryReceivingSuccess} 
                    delivery_obj={this.state.selectedDeliveryForReceiving}
                  />
                </div>
              )}
            </Modal>

            {/* Edit Delivery Modal */}
            <Modal
              title="Edit Delivery"
              visible={this.state.editModalVisible}
              onCancel={this.handleEditModalClose}
              footer={null}
              width={800}
              bodyStyle={{padding: '20px'}}
            >
              {this.state.selectedDeliveryForEdit && (
                <DeliveryEditForm 
                  delivery_obj={this.state.selectedDeliveryForEdit}
                  onSuccess={this.handleEditSuccess}
                  onCancel={this.handleEditModalClose}
                />
              )}
            </Modal>

        </div>
    )

    }

   
  }
}

export default Hub_DeliveriesList; 

